// extracted by mini-css-extract-plugin
export var actionButton = "_db-t";
export var buttonContainer = "_db-0";
export var buttonContainer2 = "_db-1";
export var buttonSection = "_db-2";
export var details = "_db-3";
export var dropdownItem = "_db-5";
export var dropdownItemsContainer = "_db-4";
export var fileInput = "_db-r";
export var headerButton = "_db-6";
export var icon = "_db-7";
export var input = "_db-8";
export var macroListItem = "_db-9";
export var mainContent = "_db-a";
export var microText = "_db-b";
export var modal = "_db-w";
export var optionsButton = "_db-c";
export var paperclip = "_db-s";
export var pillContent = "_db-d";
export var preview = "_db-e";
export var preview2 = "_db-f";
export var quillEditor = "_db-q";
export var selectedMacro = "_db-g";
export var sidebar = "_db-h";
export var sidebarHeader = "_db-j";
export var sidebarList = "_db-i";
export var sidebarListItem = "_db-k";
export var sidebarSearch = "_db-l";
export var snoozeDurationWrapper = "_db-v";
export var statusPillContainer = "_db-m";
export var tagsContainer = "_db-n";
export var unselectedMacro = "_db-o";
export var variable = "_db-u";
export var wrapper = "_db-p";